:host {
  display: block;
  width: 100%;
}

ux-copy {
  display: flex;
  gap: 5px;
  color: $color-grey-text;
  font-size: 14px;
  align-items: baseline;
}

.typing-dots {
  display: flex;
  gap: 3px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: $color-grey-text;
  border-radius: 50%;
  animation: dot-jump 1.3s infinite;
}

.dot:nth-child(2) {
  animation-delay: -1.1s;
}

.dot:nth-child(3) {
  animation-delay: -0.9s;
}

@keyframes dot-jump {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.3;
  }

  30% {
    transform: translateY(-1px);
    opacity: 1;
  }
}
